export default __webpack_public_path__ + "static/media/hospital.cf75b8f9.svg";